export default "__VITE_ASSET__oNQou89E__"